// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gdpr-section[data-v-a81f06ee] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: var(--v-primary-base);\n}\n.gdpr-section a[data-v-a81f06ee] {\n  color: var(--v-link-base);\n}", ""]);
// Exports
module.exports = exports;
